import { createContext } from '@shared/utils/createContext';

/** What produced the ordering; style curation intentionally has no telemetry source. */
export type ColorwayOrderSource = 'search' | 'colorFilter';

type GalleryColorwayOrder = Readonly<{
  /** themeId → colorway ids that matched, best-first. */
  order: ReadonlyMap<string, ReadonlyArray<string>>;
  source?: ColorwayOrderSource;
}>;

/**
 * Per-theme colorway ordering for whatever the gallery is currently narrowed by:
 * a search term, or a selected `Colors` filter. Tiles use it to sort their
 * swatches (best match first) and preselect the top one, so a card surfaced as
 * "blue" renders in its blue colorway rather than its default. Swatches are never
 * hidden — colorways absent from the list render after the ranked ones.
 *
 * `strict: false` because the context is intentionally absent outside the designs
 * gallery (e.g. favorites), where tiles behave as "nothing is narrowing this".
 */
const [GalleryColorwayOrderProvider, useGalleryColorwayOrderContext] = createContext<GalleryColorwayOrder>({
  name: 'GalleryColorwayOrderContext',
  strict: false,
});

export { GalleryColorwayOrderProvider };

export function useGalleryColorwayOrder(themeId: string): Readonly<{ colorwayIds: ReadonlyArray<string> | undefined; source: ColorwayOrderSource | undefined }> {
  const context = useGalleryColorwayOrderContext();
  return { colorwayIds: context?.order.get(themeId), source: context?.source };
}
